<template>
  <div>
        <a-card class="search-card" :bordered="false">
          <a-select :placeholder="$t('exam.selectPaper')" style="width:200px" v-model="queryParam.userPaperId">
            <a-select-option :value="undefined">{{$t('sys.all')}}</a-select-option>
            <a-select-option v-for="(p, i) in mySubmitPapers" :key="i" :value="p.id">{{p.paperId_dictText + ' ' + p.gotScore}}</a-select-option>
          </a-select>
          <a-divider type="vertical"/>
          <j-dict-select-tag :placeholder="$t('exam.selectQuestionType')" v-model="queryParam.questionType" dictCode="question_type" style="width:200px"/>
          <a-divider type="vertical"/>
          <j-category-select :placeholder="$t('exam.selectKnowleagePoint')" v-model="queryParam.knowledgePoint" pcode="A04" style="width:250px"/>
          <a-divider type="vertical"/>
          <!-- <a-input placeholder="请输入题目名" v-model="queryParam.questionName" style="width:200px"></a-input>
          <a-divider type="vertical"/> -->
          <a-input :placeholder="$t('exam.inputKW')" v-model="queryParam.questionStem" style="width:200px"></a-input>
          <a-divider type="vertical"/>
          <a-switch :checked-children="$t('exam.answer')" :un-checked-children="$t('exam.answer')" v-model="showAnswer"/>
          <a-switch :checked-children="$t('exam.analysis')" :un-checked-children="$t('exam.analysis')" v-model="showAnalysis"/>
          <a-divider type="vertical"/>
          <a-button type="primary" @click="getQuestion" icon="search">{{$t('sys.search')}}</a-button>
          <!-- <a-divider type="vertical"/>
          <a-button type="success" v-print="'#question-content'" icon="printer">{{$t('sys.print')}}</a-button> -->
        </a-card>
        <a-divider></a-divider>
        <a-card class="question-content" id="question-content" :bordered="false">
          <div v-if="queryParam.userId">
          </div>
          <div v-else>
            {{$t('exam.revisionBook')}}: {{$store.state.user.realname}}
          </div>
          <a-empty v-if="paperQuestion.length == 0"/>
          <a-row type="flex" justify="space-between">
            <a-col v-for="(q, qi) in paperQuestion" :key="qi" :span="24">
            <a-card class="question-card" :id="'q-' + qi">
              <a-row>
                <!-- 题干 -->
                <a-col>
                  <div v-if="q.questionType != 4" class="question-stem">
                    <!-- <span>{{ qi + 1 }}. （{{ q.questionScore }}{{$t('exam.point')}}）</span> -->
                    <span v-if="q.paperName">（{{q.paperName}}）</span>
                    <span v-if="!isWriteAnswer(qi)" style="color:red">{{$t('exam.noAnswer')}}</span>
                    <div v-html="q.questionStem"></div>
                  </div>
                  <div v-if="q.questionType == 4" :id="'question-stem-' + q.id"></div>
                </a-col>
                <a-divider />
                <a-col>
                  <!-- 单选 -->
                  <a-radio-group v-if="q.questionType == 1" disabled v-model="paperAnswer[qi]['myAnswer']">
                    <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                      {{ index2letter(oi) }}
                      <div class="question-options-content">
                        <div class="option" v-html="o.item"></div>
                      </div>
                    </a-radio>
                  </a-radio-group>
                  <!-- 多选 -->
                  <a-checkbox-group v-if="q.questionType == 2" disabled v-model="paperAnswer[qi]['myAnswer']">
                    <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                      {{ index2letter(oi) }}
                      <div class="question-options-content">
                        <div class="option" v-html="o.item"></div>
                      </div>
                    </a-checkbox>
                  </a-checkbox-group>
                  <!-- 判断题 -->
                  <a-radio-group v-if="q.questionType == 3" disabled v-model="paperAnswer[qi]['myAnswer']">
                    <a-radio value="true">{{$t('exam.right')}}</a-radio>
                    <a-radio value="false">{{$t('exam.wrong')}}</a-radio>
                  </a-radio-group>
                  <!-- 填空题 -->
                  <!-- 已改为虚拟DOM，直接在题干的下划线展示答案 -->
                  <!-- <div v-if="q.questionType == 4">
                      <a-input
                        readOnly
                        v-for="oi in q.questionOptions.fillGapNum"
                        :key="oi"
                        :placeholder="'第' + oi + '空回答'"
                      />
                    </div> -->
                  <!-- 主观题 阅读分析-->
                  <div v-if="q.questionType == 5 || q.questionType == 6">
                    <a-textarea :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')" readOnly v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                  </div>

                  <!-- 编程题 -->
                  <!-- OJ编程题 -->
                  <div v-if="q.questionType == 7 || q.questionType == 8">
                    <a-button type="primary" size="large" @click="openEditor(q, false)">{{$t('exam.viewTemplate')}}</a-button>
                    <a-divider type="vertical" v-if="q.questionAnalysis"></a-divider>
                    <a-button type="primary" size="large" v-if="q.questionAnalysis" @click="openEditor(q, true)"
                      >{{$t('exam.viewAnswer')}}</a-button
                    >
                  </div>
                </a-col>
              </a-row>
              <a-divider v-if="showAnswer&&showAnalysis" />
              <a-row type="flex" justify="space-between">
                <a-col :span="10" v-if="showAnswer">
                  <p style="color:red;">{{$t('exam.answer')}}：</p>
                  <span>{{ answer2Text(paperQuestion[qi]) }}</span>
                </a-col>
                <a-col :span="12" v-if="showAnalysis">
                  <p style="color:red;">{{$t('exam.analysis')}}：</p>
                  <div v-html="q.questionAnalysis"></div>
                </a-col>
              </a-row>
            </a-card>
            </a-col>
          </a-row>
        </a-card>
        <a-divider></a-divider>
        <a-pagination
          @change="pageChange"
          @showSizeChange="showSizeChange"
          :current="ipagination.current" 
          :pageSize="ipagination.pageSize"
          :pageSizeOptions="ipagination.pageSizeOptions"
          :showTotal="ipagination.showTotal"
          :total="ipagination.total"
          showQuickJumper
          showSizeChanger
          />
    <a-modal
      :width="'100%'"
      :visible="editorVisible"
      :maskClosable="false"
      :title="null"
      :dialogStyle="{ top: 0 }"
      :destroyOnClose="true"
      :footer="null"
      @cancel="editorVisible = false"
    >
      <iframe
        v-if="editorUrl"
        :src="editorUrl"
        id="player"
        frameborder="0"
        width="100%"
        style="height: calc(100vh - 48px)"
        scrolling="no"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction } from '@/api/manage'
import  { examMixins } from '@/utils/examMixins'
import { mixinDevice } from '@/utils/mixin.js'
import JCategorySelect from '@comp/jeecg/JCategorySelect'
export default {
  name: 'PaperPreview',
  mixins: [examMixins, mixinDevice],
  components: {
    JCategorySelect
  },
  data() {
    return {
      heightOffset: 0,
      paperId: '',
      questions: [],
      paperQuestion: [], //已经过转换的题目信息
      paperAnswer: [], // 答题信息
      questionSections: {}, //题目分类信息
      paperId: '', // 答题卡ID
      mySubmitPapers: [], //我提交的试卷
      queryParam: {},
      showAnswer: true, //显示答案
      showAnalysis: true, //显示解析
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50','100'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " " + this.$t('sys.total') + total + this.$t('sys.record')
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
    }
  },
  created() {
    // this.paperId = this.$route.query.id
    this.queryParam.userId = this.$route.query.userId
    this.getQuestion(this.userId)
    this.getMySubmitPaper()
  },
  mounted() {
  },
  methods: {
    //获取答卷
    pageChange(page, pageSize){
      this.paperQuestion = []
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.queryParam.pageNo = page
      this.queryParam.pageSize = pageSize
      this.getQuestion()
    },
    showSizeChange(current, size){
      this.ipagination.pageSize = size
      this.queryParam.pageSize = size
      this.getQuestion()
    },
    getMySubmitPaper(){
      getAction("/teaching/teachingUserPaper/mySubmitPaper").then(res=>{
        this.mySubmitPapers = res.result
      })
    }, 
    getQuestion(userId) {
      this.questions = []
      this.paperAnswer = []
      this.paperQuestion = []
      let url = '/teaching/teachingUserPaper/myWrongQuestion'
      if(userId){
        url = '/teaching/teachingUserPaper/userWrongQuestion'
      }
      return getAction(`/teaching/teachingUserPaper/myWrongQuestion`, this.queryParam).then((res) => {
        if (res.success && res.result != null) {
          this.ipagination.total = res.result.total;
          let questions = res.result.records
          this.parseQuestion(questions)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    parseQuestion(questions) {
      for (let qi in questions) {
        let q = questions[qi]
        //解析题目分类
        if (q.questionOptions != null) {
          q.questionOptions = JSON.parse(q.questionOptions)
        }
        this.paperQuestion.push(q)
        this.paperAnswer.push({ 
          id: q.id,
          qid: q.questionId, 
          gotScore: q.gotScore,
          reviewComment: q.reviewComment,
          myAnswer: this.parseAnswer(q.questionType, q.myAnswer), 
          myAnswerFile: q.myAnswerFile })
        //渲染填空题dom
        if (q.questionType == 4) {
          this.renderGapFillingStemDom(q, qi)
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
.question-index {
  text-align: left;
  .question-section {
    margin: 10px 0px;
  }
  .ant-tag {
    height: 30px;
    width: 30px;
    font-size: 14px;
    line-height: 28px;
  }
}
.question-content {
  .question-card {
    margin-bottom: 20px;
  }
  .question-stem {
    width: 100%;
    max-height: 500px;
    overflow: auto;
    span,
    > div {
      display: inline-block;
      vertical-align: top;
    }
  }
  .ant-radio-wrapper,
  .ant-checkbox-wrapper {
    display: block !important;
    margin-left: 0px;
  }
  .question-options-content {
    display: inline-block;
  }
}
</style>

<style media="print">
@page {
  size: auto; /* auto is the initial value */
  margin: 3mm; /* this affects the margin in the printer settings */
}
</style>
